'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('../common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('../common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('../common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'eSignatures SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'HelloSign\'s Intro to eSignatures',
            subtitle: 'Already an eSignature pro? Create your HelloSign account and send your first eSignature.',
            buttonText: 'GET ESIGNING'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _react2['default'].createElement(
            _bodySection2['default'],
            null,
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'What is an eSignature?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'According to the ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://www.techlawjournal.com/cong106/digsig/Default.htm',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'U.S. Federal ESIGN Act'
                ),
                ' passed in 2000, an electronic signature is an "electronic sound, symbol, or process, attached to or logically associated with a contract or other record and executed or adopted by a person with the intent to sign the record."'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'In other words, when a signer signs an online document willfully and intentionally, it\u2019s considered an eSignature. An eSignature works largely the same way as a handwritten or \u201Cwet\u201D signature.'
            ),
            _react2['default'].createElement(
                'div',
                { className: 'text-center l-padding-t-60' },
                _react2['default'].createElement('img', {
                    src: require('images/info/signature_modal@2x.png'),
                    alt: 'Signature Modal',
                    className: 'm-marketing-page--image-signature-modal'
                })
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Are eSignatures secure?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'eSignatures have been considered a legally binding way to sign documents and paperwork since 2000 and the security of eSignatures depends in large part on the provider of your eSignatures. Here are some of the critical security checkpoints to check off before using any eSignature service:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'SSL hosting'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Encryption at rest'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Secure data storage (HelloSign uses an SSAE 16 Certified Data Center)'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Additional security features like ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'http://blog.hellosign.com/esignature-two-factor-authentication',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'two-factor authentication'
                    ),
                    ' and ',
                    _react2['default'].createElement(
                        'a',
                        {
                            href: 'https://faq.hellosign.com/hc/en-us/articles/205814918-What-Is-An-Audit-Trail',
                            target: '_blank', rel: 'noopener noreferrer' },
                        'audit trails'
                    )
                )
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can learn more about HelloSign\'s security ',
                _react2['default'].createElement(
                    'a',
                    { href: '/info/security',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'here'
                ),
                ' and ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/are-esignatures-secure',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Are eSignatures legal?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Yes! eSignatures are a legally binding and accepted form of signature in the US, Canada, the UK, and parts of the world.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'As it stands today, 47 of the 50 united states have signed the UETA. The remaining three states (Washington, New York, and Illinois) have passed their own laws regarding the legal status of eSignatures.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'You can learn more about the legality of eSignatures ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: '/info/legal', target: '_blank', rel: 'noopener noreferrer' },
                    'here'
                ),
                ' and ',
                _react2['default'].createElement(
                    'a',
                    {
                        href: 'http://blog.hellosign.com/esignatures-legal-handwritten-signatures',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'here'
                ),
                '.'
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'Who uses eSignatures?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'eSignatures are used to sign all types of documents and paperwork, from simple one sheet agreements to complex mortgage and loan paperwork.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Here are just a few examples of how eSignatures are being used:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Sales teams are closing deals faster by streamlining the signing process'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'HR directors using eSignatures to simplify complicated onboarding paperwork'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Real estate agents are signing housing contracts'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Schools and administrative industries are easily signing applications and releases'
                )
            ),
            _react2['default'].createElement(
                'h2',
                { className: headerClass },
                'How else are HelloSign eSignatures used?'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'Anyone can use HelloSign\u2019s stand alone product to sign documents or request eSignatures through our website, but many choose to use the HelloSign API to build eSignatures directly into their site.'
            ),
            _react2['default'].createElement(
                'p',
                null,
                'With the HelloSign eSignature API you can:'
            ),
            _react2['default'].createElement(
                'ul',
                { className: listClass },
                _react2['default'].createElement(
                    'li',
                    null,
                    'Keep signers on your page by embedding eSignatures into online paperwork flows'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Customize the signer\'s experience with white-labeling'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Remove the extra step of sending signers to a third-party site to sign documents'
                ),
                _react2['default'].createElement(
                    'li',
                    null,
                    'Automate your paperwork to sign documents faster'
                )
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Ready to eSign your first document? It only takes a few minutes.',
            subtitle: 'If you’re ready to start eSigning, set up a HelloSign account to try it out. If you want to learn more, schedule a demo and we’ll walk you through all our features.',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl,
            apiUsersHeaderText: 'LOOK WHO\'S USING HELLOSIGN',
            embeddedTweetsHeaderText: 'HAPPY TWEETS FROM HAPPY USERS'
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return _react2['default'].createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/esignatures.jsx
 ** module id = 1228
 ** module chunks = 0
 **/